import React from 'react';
import PropTypes from 'prop-types';

const NotificationIcon = ({
  status,
  type,
  className,
}) => {
  const checkStatus = () => {
    switch (status) {
      case 'new':
        return 'new';

      case 'nudge':
        return 'nudge';

      case 'alert':
      case 'system':
      case 'announcement':
        return 'alert';

      case 'update_pending':
        return 'update-pending';

      case 'update_success':
      case 'update_reject':
      case 'closed_success':
      case 'closed_reject':
        return 'update-success-reject';

      case 'reassign':
        return 'reassign';

      case 'others':
      case 'update':
      default:
        return 'update';
    }
  };
  return (
    <div className={`notification-icon ${className} ${status} ${type || ''}`}>
      <img
        src={`/assets/icons/notification/${checkStatus()}.svg`}
        alt={`Alert for ${status.replace('_', ' ')}`}
      />
    </div>
  );
};


NotificationIcon.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default NotificationIcon;



// WEBPACK FOOTER //
// ./src/components/Bookings/LeadActivity/NotificationIcon.jsx